import { render, staticRenderFns } from "./Pygn.vue?vue&type=template&id=e77c35a2&"
import script from "./Pygn.vue?vue&type=script&lang=js&"
export * from "./Pygn.vue?vue&type=script&lang=js&"
import style0 from "./Pygn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports